// current discount codes in use
export const DISCOUNT_EAN_CODES = [
  '0200969012100',
  '0200412021499',
  '0200412021444',
  '0200409061408',
]
